import Swiper, { Autoplay, EffectCreative, Navigation, Pagination } from "swiper";
import gsap from "gsap";

document.addEventListener("DOMContentLoaded", function () {
  const detailsListElems = document.querySelectorAll(".details-list");

  detailsListElems.forEach((detailsList) => {
    let detailsListSlider;

    // Switch between block between simple
    function initDetailsListSlider() {
      if (window.innerWidth >= 779 && detailsListSlider) {
        detailsListSlider?.destroy();
        detailsListSlider = undefined;
      } else if (window.innerWidth < 779 && !detailsListSlider) {
        let sliderToActivate = null;
        if (materialSwitcher.checked) {
          sliderToActivate = detailsList.querySelectorAll(".details-list__slider")[1];
        } else {
          sliderToActivate = detailsList.querySelectorAll(".details-list__slider")[0];
        }
        detailsListSlider = new Swiper(sliderToActivate, {
          modules: [Navigation, Autoplay, EffectCreative, Pagination],
          slideClass: "details-list__item",
          slidesPerView: 1,
          slidesPerGroup: 1,
          centeredSlides: true,
          spaceBetween: 0,
          pagination: {
            el: sliderToActivate.querySelector(".swiper-pagination"),
            clickable: true,
            bulletClass: "details-list__pagination pagination__item",
            bulletActiveClass: "pagination__item--active",
          },
        });
      }
    }

    window.addEventListener("resize", function () {
      initDetailsListSlider();
    });

    const materialSwitcherContainer = detailsList.querySelector(".tuning-buttons__material");
    const materialSwitcher = detailsList.querySelector(".tuning-buttons__input");
    const material1 = materialSwitcher.dataset.unchecked;
    const material2 = materialSwitcher.dataset.checked;
    const detailsListMaterial1 = detailsList.querySelector(`.details-list__items-container[data-material=${material1}]`);
    const detailsListMaterial2 = detailsList.querySelector(`.details-list__items-container[data-material=${material2}]`);
    const sortSwitcher = detailsList.querySelector(".sort-switcher__input");
    const showMoreBtn = detailsList.querySelector(".details-list__show-more-btn");
    let detailsListItemsContainer = detailsList.querySelector(".details-list__items-container.shown");
    let detailsListContainer = detailsList.querySelector(".details-list__container");
    const tuningGloss = document.querySelector(".tuning--gloss");
    const tuningCarbon = document.querySelector(".tuning--carbon");
    let currentTuningHeight = 0;
    let newTuningHeight = 0;
    let scrollChange = 0;

    let timeLine = gsap.timeline();

    const showAllElems = () => {
      materialSwitcherContainer.style.pointerEvents = "all";
      detailsListContainer.style.height = "unset";
      showMoreBtn.style.opacity = "1";

      scrollChange = currentTuningHeight - newTuningHeight;

      tuningCarbon?.style.removeProperty("min-height");
      tuningCarbon?.style.removeProperty("max-height");
      tuningGloss?.style.removeProperty("min-height");
      tuningGloss?.style.removeProperty("max-height");

      // fix scroll jumping on Safari
      if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
        document.documentElement.scrollTop -= scrollChange;
      }
    };

    const getElementHeight = (el) => {
      let height = 0;
      if (el) {
        let curHeight = el.offsetHeight;
        el.style.removeProperty("min-height");
        el.style.removeProperty("max-height");
        height = el.offsetHeight;
        el.style.minHeight = curHeight;
        el.style.maxHeight = curHeight;
      }

      return height;
    };

    //Toggle mobile sliders after change material
    const reInitSlider = (saveActiveSlide = false) => {
      let sliderToShow = null;
      let sliderToHide = null;

      if (materialSwitcher.checked) {
        sliderToShow = detailsList.querySelectorAll(".details-list__slider")[1];
        sliderToHide = detailsList.querySelectorAll(".details-list__slider")[0];

        currentTuningHeight = getElementHeight(tuningGloss);
        if (tuningGloss) {
          tuningGloss.style.minHeight = tuningGloss.style.maxHeight = currentTuningHeight + "px";
        }
      } else {
        sliderToShow = detailsList.querySelectorAll(".details-list__slider")[0];
        sliderToHide = detailsList.querySelectorAll(".details-list__slider")[1];

        currentTuningHeight = getElementHeight(tuningCarbon);
        if (tuningCarbon) {
          tuningCarbon.style.minHeight = tuningCarbon.style.maxHeight = currentTuningHeight + "px";
        }
      }

      if (window.innerWidth < 779) {
        const activeSlideIdx = saveActiveSlide ? detailsListSlider?.activeIndex : 0;
        timeLine.to(sliderToHide, {
          duration: 0.3,
          autoAlpha: 0,
          display: "none",
          onComplete: () => {
            sliderToHide.classList.remove("shown");
            detailsListSlider?.destroy(true, true);
            detailsListSlider = new Swiper(sliderToShow, {
              modules: [Navigation, Autoplay, EffectCreative, Pagination],
              slideClass: "details-list__item",
              slidesPerView: 1,
              slidesPerGroup: 1,
              centeredSlides: true,
              spaceBetween: 0,
              initialSlide: activeSlideIdx,
              pagination: {
                el: sliderToShow.querySelector(".swiper-pagination"),
                clickable: true,
                bulletClass: "details-list__pagination pagination__item",
                bulletActiveClass: "pagination__item--active",
              },
            });
          },
        });
        timeLine.to(sliderToShow, {
          duration: 0,
          autoAlpha: 0,
          display: "none",
        });
        timeLine.to(sliderToShow, {
          duration: 0.3,
          autoAlpha: 1,
          display: "block",
          onComplete: () => {
            sliderToShow.classList.add("shown");
            if (materialSwitcher.checked) {
              newTuningHeight = getElementHeight(tuningGloss);
            } else {
              newTuningHeight = getElementHeight(tuningCarbon);
            }
            showAllElems();
          },
        });
      }
    };

    // Show/hide items from different material
    const toggleMaterial = () => {
      if (materialSwitcher.checked) {
        currentTuningHeight = getElementHeight(tuningCarbon);
        if (tuningCarbon) {
          tuningCarbon.style.minHeight = tuningCarbon.style.maxHeight = currentTuningHeight + "px";
        }
        timeLine.to(detailsListMaterial1, {
          duration: 0.3,
          autoAlpha: 0,
          display: "none",
          onComplete: () => {
            detailsListMaterial1.classList.remove("shown");
          },
        });
        timeLine.to(detailsListMaterial2, {
          duration: 0.3,
          autoAlpha: 1,
          display: "block",
          onComplete: () => {
            detailsListMaterial2.classList.add("shown");
            newTuningHeight = tuningGloss?.offsetHeight;
            showAllElems();
          },
        });
      } else {
        currentTuningHeight = getElementHeight(tuningGloss);

        timeLine.to(detailsListMaterial2, {
          duration: 0.3,
          autoAlpha: 0,
          display: "none",
          onComplete: () => {
            detailsListMaterial2.classList.remove("shown");
          },
        });

        timeLine.to(detailsListMaterial1, {
          duration: 0.3,
          autoAlpha: 1,
          display: "block",
          onComplete: () => {
            detailsListMaterial1.classList.add("shown");
            newTuningHeight = tuningCarbon?.offsetHeight;
            showAllElems();
          },
        });
      }
    };

    toggleMaterial();
    initDetailsListSlider();

    //Reverse items in container
    const toggleSorting = (container) => {
      const items = container.querySelectorAll(".details-list__item");
      if (sortSwitcher.checked) {
        for (let i = items.length - 1; i >= 0; i--) {
          items[i].style.order = items.length - i;
          // detailsListMaterial1.appendChild(items[i]); // Перемещает дочерние элементы в обратном порядке
        }
      } else {
        for (let i = 0; i <= items.length - 1; i++) {
          items[i].style.order = i + 1;
          // detailsListMaterial1.appendChild(items[i]); // Перемещает дочерние элементы в обратном порядке
        }
      }
    };

    materialSwitcher.addEventListener("change", () => {
      materialSwitcherContainer.style.pointerEvents = "none";
      showMoreBtn.style.opacity = "0";
      detailsListContainer.style.height = window.getComputedStyle(detailsListContainer).height;
      if (window.innerWidth >= 779) {
        toggleMaterial();
      } else {
        reInitSlider();
      }
    });

    sortSwitcher.addEventListener("change", () => {
      toggleSorting(detailsListMaterial1);
      toggleSorting(detailsListMaterial2);
    });

    const showNextElements = (container, chunkSize) => {
      const items = container.querySelectorAll(".details-list__item:not(.shown)");
      for (let i = 0; i < chunkSize && i < items.length; i++) {
        items[i].classList.add("shown");
      }
    };

    showNextElements(detailsListMaterial1, 8);
    showNextElements(detailsListMaterial2, 8);

    showMoreBtn.addEventListener("click", () => {
      showNextElements(detailsListMaterial1, 8);
      showNextElements(detailsListMaterial2, 8);
      reInitSlider(true);
      if (Array.from(detailsList.querySelectorAll(".details-list__item:not(.shown)")).length == 0) {
        showMoreBtn.classList.add("hidden");
      }
    });
  });
});
